module.exports = __webpack_public_path__ + "static/media/up-right-from-square-solid_r.4a06d7c2.svg";